import { Box, Typography } from "@material-ui/core";
import { ActionButton } from "halifax";
import React from "react";
import { BookedFlightItineraryWithDepartureTime } from "redmond";
import { FlightTicketsIcon } from "./FlightTicketsIcon";
import "./styles.scss";

const CORPORATE_PORTAL_URL =
  window.__mclean_env__?.CORPORATE_PORTAL_URL || "";

interface FlightDisruptionRebookingRedirectModalContentProps {
  onClose?: () => void;
  flight: BookedFlightItineraryWithDepartureTime;
}

export const FlightDisruptionRebookingRedirectModalContent: React.FC<
  FlightDisruptionRebookingRedirectModalContentProps
> = ({ onClose, flight }) => {
  const handleContinue = () => {
    const tripId = flight.bookedItinerary.id;
    const url = `${CORPORATE_PORTAL_URL}/trips/?tripId=${encodeURIComponent(tripId)}`;
    window.open(url, "_blank")?.focus();
    onClose?.();
  };

  return (
    <Box className="flight-disruption-rebooking-redirect-modal-root">
      <Box className="flight-disruption-rebooking-redirect-modal-header">
        <FlightTicketsIcon />
        <Typography
          variant="h2"
          className="flight-disruption-rebooking-redirect-modal-title"
        >
          We're here to help
        </Typography>
        <Typography
          variant="body1"
          className="flight-disruption-rebooking-redirect-modal-description"
        >
          To see your rebooking options, you’ll need to manage this flight on
          Capital One Business Travel.
        </Typography>
      </Box>
      <Box className="flight-disruption-rebooking-redirect-modal-actions">
        <ActionButton
          defaultStyle="h4r-secondary"
          message="Cancel"
          onClick={() => onClose?.()}
        />
        <ActionButton
          defaultStyle="h4r-primary"
          message="Continue to Capital One Business Travel"
          onClick={handleContinue}
        />
      </Box>
    </Box>
  );
};
